import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var myLicence = [{
  path: "my-licence",
  name: "my-licence",
  component: function component() {
    return import("./my-licence.vue");
  }
}];